import React from "react";
import { Navigate } from "react-router-dom";
import { axiosClient } from "../../helpers/axios";
import { useSelector } from "react-redux";
import Footer from "../main/Footer";

const MiddlewareAuth = ({ children }) => {

  const user = useSelector((state) => state.Login.auth);
  console.log(user, 'loadsnis')
  const token = '';
  axiosClient.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      if (error.respose.satus == 401) {
        //resetAuthStore()
      }
      return Promise.reject(error)
    }
  );

  if (user && user.isAuth) {
    return (
      <>
        <div className="flex flex-row max-h-screen mb-[55px]">
          <div className="w-full h-screen overflow-auto bg-mts-gray">
            {children}
          </div>
          <Footer />
        </div>
        
      </>
    )
  } else {
    return <Navigate to="/login" />
  }

  /*if(children.type.name == 'Login'){
  return loggedIn ? children : <Navigate to="/"/>;
}else{
  return loggedIn ? children : <Navigate to="/login"/>
}*/

}

export default MiddlewareAuth